module.exports = __webpack_public_path__ + "assets/5d523ddd9715a54930c7923a989cf66a.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/Reveal.mp3
 ** module id = 248
 ** module chunks = 0
 **/